<template>
  <div class="page-vue-embed">
    <div class="dc_form-wrapper">
      <v-app id="dehn_dc_form">
        <v-main>
          <!--
          <div class="dehn-chapter dehn-bgcolor__red dehn-invert-color">
            <v-container class="dc_form-container__outer">
              <intro></intro>
            </v-container>
          </div>
          -->
          <v-container class="dc_form-container__outer">
            <v-alert
              v-if="this.errors[0]"
              border="right"
              colored-border
              type="error"
              elevation="2"
            >
              Entschuldigung: Es ist ein Fehler aufgetreten. Laden Sie die Seite neu oder versuchen Sie es später noch einmal.
            </v-alert>
            <v-container fluid>
              <v-row>
                <v-col cols="12" md="9">
                  <h1 class="text-h2 text-md-h1" style="color:#fff;">DEHNconcept Projektinformationsblatt</h1>
                </v-col>
              </v-row>
            </v-container>
            <stepper
              v-if="!errors[0]"
              :userRoles="userRoles"
            ></stepper>
          </v-container>
        </v-main>
      </v-app>
    </div>
  </div>
</template>

<script>

import Stepper from "./components/Stepper";

export default {
  name: 'App',
  components: {
    Stepper,
  },
  data: () => ({
    instanceId: '',
    lang: 'de',
    userRoles: [],
    errors: []

  }),
  computed:{
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  },
  beforeMount () {
    // Get the ID tag containing the drupal instance id.
    this.instanceId = this.$parent.$el.id;
    let lang = document.getElementsByTagName('html')[0].getAttribute('lang')
    this.lang = lang;
    let userRoles = document.getElementsByTagName('body')[0].getAttribute('class').match(/user-has-role-[^\s]+/g);
    this.userRoles = userRoles.map(function(x){return x.replace('user-has-role-','');});
  }
};
</script>

<style lang="scss">

@import '../src/sass/variables.scss';

.v-application {
  background-color: var(--v-background-base) !important;
}

h1 {
  color: $c-dehn-white;
}

.theme--light.v-application {
  background: $c-dehn-gray--lighter !important;
}

.dehn-bgcolor__light {
  background: $c-dehn-gray--lighter;
}

.dehn-bgcolor__white {
  background: $c-dehn-white;
}

.dehn-bgcolor__dark {
  background: $c-dehn-gray--darkest;
}

.dehn-bgcolor__red {
  background: $c-dehn-red;
}

.dc_form-container__outer {
  padding: 0 $container-padding-x-small;
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .dc_form-container__outer {
    padding: 0 $container-padding-x-medium 48px $container-padding-x-medium;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .dc_form-container__outer {
    margin-bottom: 48px;
  }
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .dc_form-container__outer {
    padding: 48px $container-padding-x-medium;
  }
}

@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .dc_form-container__outer {
    padding: 48px $container-padding-x-large;
  }
}

</style>
